"use client";

import { Loader, Star } from "lucide-react";
import { useProfileContext } from "../../../context/ProfileContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProfileSelection = () => {
  const { profiles, selectedProfile, handleProfileSelect } =
    useProfileContext();

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 15000); // Simulate loading for 15 seconds
    return () => clearTimeout(timer);
  }, []);

  const router = useNavigate();
  return (
    <div className="text-center">
      <h3 className="text-3xl font-bold text-purple-700 mb-6 animate-fade-in-up">
        Choose Your Profile
      </h3>

      <div className="h-80 overflow-y-auto bg-white/20 backdrop-blur-sm rounded-3xl p-4 shadow-inner border border-white/30 scrollbar-custom">
        <div className="grid grid-cols-1 gap-4 justify-center items-center">
          {isLoading ? (
            <Loader className="mx-auto animate-spin text-purple-500 w-12 h-12" />
          ) : (
            <>
              {profiles.map((profile, index) => (
                <div
                  key={profile.studentId}
                  className={`${
                    index % 2 === 0
                      ? "bg-gradient-to-r from-purple-500 to-pink-500"
                      : "bg-gradient-to-r from-blue-500 to-green-500"
                  } p-4 rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl ${
                    selectedProfile?.studentId === profile.studentId
                      ? "ring-4 ring-yellow-400 scale-105"
                      : ""
                  }`}
                  onClick={() => handleProfileSelect(profile)}
                >
                  <div className="flex items-center space-x-3">
                    <div className="text-4xl animate-bounce">👦</div>
                    <div className="text-left flex-grow">
                      <h4 className="text-xl font-bold text-white">
                        {profile.studentName}
                      </h4>
                      <p className="text-white/80 text-sm">
                        Class: {profile.classId}
                      </p>
                    </div>
                    {selectedProfile?.studentId === profile.studentId && (
                      <div className="animate-spin">
                        <Star className="w-6 h-6 text-yellow-300 fill-current" />
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <div
                key={"teacher"}
                className={`${
                  true
                    ? "bg-gradient-to-r from-purple-500 to-pink-500"
                    : "bg-gradient-to-r from-blue-500 to-green-500"
                } p-4 rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl`}
                onClick={() => router("/teacher-dashboard")}
              >
                <div className="flex items-center space-x-3">
                  <div className="text-4xl animate-bounce">👦</div>
                  <div className="text-left flex-grow">
                    <h4 className="text-xl font-bold text-white">Teacher</h4>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileSelection;
